export const configuration = {
    src: "/static/js/portal.v7-uber.js",
    async: false,
    onload: () => {
        window.APIMaticDevPortal.show({
            container: "apimatic-widget",
            portalStyle: "default",
            codegenApiRoutes: {
                docsgen: "/static/docs/goeapi-{template}.json",
                codegen: "/static/sdks/goeapi-{template}.zip",
                transform: "/static/exports/goeapi-{format}.{ext}",
            },
            apiKey: "xxx",
            baseUrl: "./",
            enableExport: true,
            renameHttpToRest: false,
            enableConsoleCalls: true,
            useProxyForConsoleCalls: false,
            initialPlatform: "http_curl_v1",
            useLegacyApiPlayground: true,
            globalPageMetaData: {
                pageMode: "wide"
            },
            theme: {
                // Choose the base theme
                baseTheme: "standard", // "standard" & "cosmos"

                // Color variables
                colors: {
                    primaryColor: {
                        light: "#0C7FF2", // Changed the color of "Introduction in the RSB"
                        dark: "#7CBAF8",
                    },
                    linkColor: {
                        light: "#004AD7",
                        dark: "#66B2FF",
                    },
                },

                // Color mode settings
                colorMode: {
                    defaultMode: "light", // Changed the bg of app to dark and text to white
                    disableSwitch: false, // Implementation should be inverted
                },
                fontSource: [
                    // Using this font in heading and body text
                    "https://fonts.googleapis.com/css?family=Rubik:100,100i,300,300i,400,400i,500,500i,700,700i,900,900i",
                    // Using this font in inline and block code samples
                    "https://fonts.googleapis.com/css?family=Courier+Prime:100,100i,300,300i,400,400i,500,500i,700,700i,900,900i",
                ],
                cssStyles: {
                    // Customize the typography for different heading levels
                    headings: {
                        fontFamily: '"Rubik", sans-serif', // Add your font-family name here
                        "h1": {
                            "fontFamily": "'Rubik', sans-serif",
                            "fontSize": "27px",
                            "fontWeight": "500",
                            "fontStyle": "normal",
                            "lineHeight": "1.3"
                        },
                        "h2": {
                            "fontFamily": "'Rubik', sans-serif",
                            "fontSize": "24px",
                            "fontWeight": "500",
                            "fontStyle": "normal",
                            "lineHeight": "1.3"
                        },
                        "h3": {
                            "fontFamily": "'Rubik', sans-serif",
                            "fontSize": "21.36px",
                            "fontWeight": "500",
                            "fontStyle": "normal",
                            "lineHeight": "1.3"
                        },
                        "h4": {
                            "fontFamily": "'Rubik', sans-serif",
                            "fontSize": "18px",
                            "fontWeight": "500",
                            "fontStyle": "normal",
                            "lineHeight": "1.3"
                        },
                        "h5": {
                            "fontFamily": "'Rubik', sans-serif",
                            "fontSize": "16px",
                            "fontWeight": "500",
                            "fontStyle": "normal",
                            "lineHeight": "1.3"
                        },
                        "h6": {
                            "fontFamily": "'Rubik', sans-serif",
                            "fontSize": "15px",
                            "fontWeight": "500",
                            "fontStyle": "normal",
                            "lineHeight": "1.3"
                        }
                    },
                    // Customize the typography for different bode text level
                    body: {
                        fontFamily: '"Rubik", sans-serif', // Add your font-family name here
                        // Refers to the paragraph text.
                        text1: {
                            fontFamily: '"Rubik", sans-serif',
                            fontSize: "15px",
                            fontWeight: "400",
                            fontStyle: "normal",
                            lineHeight: "1.75",
                            textTransform: "none",
                        },
                        text2: {
                            fontFamily: '"Rubik", sans-serif',
                            fontSize: "13.33px",
                            fontWeight: "400",
                            fontStyle: "normal",
                            lineHeight: "1.75",
                            textTransform: "none",
                        },
                        text3: {
                            fontFamily: '"Rubik", sans-serif',
                            fontSize: "11.85px",
                            fontWeight: "400",
                            fontStyle: "normal",
                            lineHeight: "1.75",
                            textTransform: "none",
                        },
                    },
                    // Customize the typography for different code samples.
                    code: {
                        fontFamily: "Courier Prime, monospace",
                        // Method Signature code block, Code Samples on right side, Example response code block.
                        blockCode: {
                            fontFamily: "Courier Prime, monospace",
                            fontSize: "14.22px",
                            fontWeight: "400",
                            fontStyle: "normal",
                            lineHeight: "1.75",
                        },
                        inlineCode: {
                            fontFamily: "Courier Prime, monospace",
                            fontSize: "14.22px",
                            fontWeight: "400",
                            fontStyle: "normal",
                            lineHeight: "1.75",
                        },
                    },
                },
            },
            languageSettings: {
                "http_curl_v1": {
                    "sdkDownloadLink": "",
                    "disableSdkDownload": false
                },
                "java_eclipse_jre_lib": {
                    "sdkDownloadLink": "",
                    "disableSdkDownload": false
                },
                "python_generic_lib": {
                    "sdkDownloadLink": "",
                    "disableSdkDownload": false
                }
            },
            allowedExportFormats: [
                "postman10",
                "postman20",
                "openapi31json",
                "openapi31yaml",
                "openapi3json",
                "openapi3yaml",
                "swagger20",
                "swaggeryaml",
                "swagger10",
                "raml",
                "raml10",
                "apiblueprint",
                "wadl2009",
                "apimatic",
                "wsdl",
                "insomnia",
                "insomniayaml",
            ],
        });
        window.APIMaticDevPortal.ready(({ registerWorkflow }) => {
            if (window.RetirementWalkthrough) {
                registerWorkflow('page:guided-walkthroughs/walkthrough-1',
                    'Retirement with Decumulation',
                    window.RetirementWalkthrough
                );
            }
            if (window.InfusionArrayCreationWalkthrough) {
                registerWorkflow('page:guided-walkthroughs/walkthrough-2',
                    'Infusion Array',
                    window.InfusionArrayCreationWalkthrough
                );
            }
            if (window.RetirementAccumulationWalkthrough) {
                registerWorkflow('page:guided-walkthroughs/walkthrough-3',
                    'Retirement Advice with Accumulation/Decumulation',
                    window.RetirementAccumulationWalkthrough
                );
            }
            if (window.WealthAccumulationCoreWalkthrough) {
                registerWorkflow('page:guided-walkthroughs/walkthrough-4',
                    'Wealth Goal (w/Core API)',
                    window.WealthAccumulationCoreWalkthrough
                );
            }
            if (window.WealthGoalUpdatedAccountBalanceWalkthrough) {
                registerWorkflow('page:guided-walkthroughs/walkthrough-5',
                    'Updated Account Balance',
                    window.WealthGoalUpdatedAccountBalanceWalkthrough
                );
            }
            if (window.WealthGoalMissedInfusionsWalkthrough) {
                registerWorkflow('page:guided-walkthroughs/walkthrough-6',
                    'Missed Contributions',
                    window.WealthGoalMissedInfusionsWalkthrough
                );
            }
            if (window.WealthGoalUpdatedRiskProfileWalkthrough) {
                registerWorkflow('page:guided-walkthroughs/walkthrough-7',
                    'Updated Risk Profile',
                    window.WealthGoalUpdatedRiskProfileWalkthrough
                );
            }
            if (window.WealthGoalUpdatedGoalPriorityWalkthrough) {
                registerWorkflow('page:guided-walkthroughs/walkthrough-8',
                    'Updated Goal Priority',
                    window.WealthGoalUpdatedGoalPriorityWalkthrough
                );
            }
            if (window.WealthGoalUpdatedGoalAmountWalkthrough) {
                registerWorkflow('page:guided-walkthroughs/walkthrough-9',
                    'Updated Goal Amount',
                    window.WealthGoalUpdatedGoalAmountWalkthrough
                );
            }
            if (window.WealthGoalUpdatedReallocationWalkthrough) {
                registerWorkflow('page:guided-walkthroughs/walkthrough-10',
                    'Updated Reallocation',
                    window.WealthGoalUpdatedReallocationWalkthrough
                );
            }
            if (window.WealthGoalUpdatedCMEDataWalkthrough) {
                registerWorkflow('page:guided-walkthroughs/walkthrough-11',
                    'Updated CME Data',
                    window.WealthGoalUpdatedCMEDataWalkthrough
                );
            }
            if (window.WealthGoaltoViewUpdatedProbabilityWalkthrough) {
                registerWorkflow('page:guided-walkthroughs/walkthrough-12',
                    'Updated Probability',
                    window.WealthGoaltoViewUpdatedProbabilityWalkthrough
                );
            }
            // if (window.SignInWalkthrough) {
            //     registerWorkflow('page:guided-walkthroughs/walkthrough-13',
            //         'Sign In',
            //         window.SignInWalkthrough);
            // }
            if (window.TagretingSinglePortfolioWalkthrough) {
                registerWorkflow('page:guided-walkthroughs/walkthrough-14',
                    'Targeting a Single Portfolio (Under Development)',
                    window.TagretingSinglePortfolioWalkthrough);
            }
            if (window.ShortTermWealthGoalWalkthrough) {
                registerWorkflow('page:guided-walkthroughs/walkthrough-15',
                    'Short Term Wealth Goal',
                    window.ShortTermWealthGoalWalkthrough);
            }
            // if (window.CallingGOEDecumulationWalkthrough) {
            //     registerWorkflow('page:guided-walkthroughs/walkthrough-16',
            //         'Calling GOE for Decumulation (Under Development)',
            //         window.CallingGOEDecumulationWalkthrough);
            // }
            if (window.CallingGOEwithAnnuitiesWalkthrough) {
                registerWorkflow('page:guided-walkthroughs/walkthrough-17',
                    'Calling GOE with Annuities (Under Development)',
                    window.CallingGOEwithAnnuitiesWalkthrough);
            }
            // if (window.CapEquityAllocationWalkthrough) {
            //     registerWorkflow('page:guided-walkthroughs/walkthrough-18',
            //         'Retirement Planning with a Cap Equity Allocation',
            //         window.CapEquityAllocationWalkthrough);
            // }
            // if (window.FloorsEquityAllocationWalkthrough) {
            //     registerWorkflow('page:guided-walkthroughs/walkthrough-19',
            //         'Retirement Planning with a Floor Equity Allocation',
            //         window.FloorsEquityAllocationWalkthrough);
            // }
            if (window.GOEforTaxesWalkthrough) {
                registerWorkflow('page:guided-walkthroughs/walkthrough-20',
                    'Calling GOE for Taxes',
                    window.GOEforTaxesWalkthrough);
            }
            if (window.GoalSimulationEngineWalkthrough) {
                registerWorkflow('page:guided-walkthroughs/walkthrough-21',
                    'Calling Goal Simulation Engine',
                    window.GoalSimulationEngineWalkthrough);
            }
            if (window.OverridingDefaultEquityAllocationWalkthrough) {
                registerWorkflow('page:guided-walkthroughs/walkthrough-23',
                    'Overriding Default Equity Caps and Floors',
                    window.OverridingDefaultEquityAllocationWalkthrough);
            }
            // if (window.RetirementAdviceWithInflationWalkthrough) {
            //     registerWorkflow('page:guided-walkthroughs/walkthrough-22',
            //         'Retirement Advice with Inflation',
            //         window.RetirementAdviceWithInflationWalkthrough);
            // }
            if (window.TradeAdviceWalkthrough) {
                registerWorkflow('page:guided-walkthroughs/walkthrough-24',
                    'Advice Status (Under Development)',
                    window.TradeAdviceWalkthrough);
            }
        });
        window.APIMaticDevPortal.ready(({ setConfig }) =>
            setConfig((defaultConfig) => {
                return {
                    ...defaultConfig,
                    auth: {
                        JWTBearer: {
                            ...defaultConfig.auth.JWTBearer,
                            "AccessToken": localStorage.getItem("accessToken") || "",
                        }
                    }
                };
            })
        );
    },
};